import { withContextStore } from '@doltech/core/lib/entity/store';
import { compose } from '@doltech/utils/lib/compose';
import { branch } from '@doltech/utils/lib/branch';

import { withVocabFlowToolbarStore } from '../../../shared/components/IELTSample/ViewVocabFlow/toolbars/vocab-flow-toolbar.store';
import { withDolEditorStore } from '../../DolEditor/dol-editor.store';
import {
  FileUpload,
  FileUploadStoreContext,
  withInitMediaInfos,
} from '../../DolEditor/elements/BlogEditor/model/file-upload-model';
import { withBlogEditorStore } from '../blog-editor.store';
import { withDoExerciseProgressContext } from '../shared-components/Exercise/DoExerciseProgressContext';
import { withDoExerciseProgress } from '../shared-components/Exercise/withDoExerciseProgress';
import { withSimpleAudioPlayInBackground } from '../../../hooks/simple-audio-play-in-background.store';

interface WithStoreEditorOptions {
  haveDoTestExercise?: boolean;
  initFileUploadImmediately?: boolean;
  withoutAudio?: boolean;
}

export const withStoreRequiredForEditor = (hocOptions: WithStoreEditorOptions) => {
  const {
    haveDoTestExercise = true,
    initFileUploadImmediately = false,
    withoutAudio = false,
  } = hocOptions;
  return compose(
    withDolEditorStore,
    withBlogEditorStore,

    branch(() => !withoutAudio, withSimpleAudioPlayInBackground),
    withContextStore(
      {
        fileUploadStore: {
          model: FileUpload,
          defaultValue: {},
        },
      },
      FileUploadStoreContext
    ),
    withVocabFlowToolbarStore,
    branch(
      () => haveDoTestExercise,
      compose(withDoExerciseProgressContext, withDoExerciseProgress)
    ),
    branch(() => initFileUploadImmediately, withInitMediaInfos)
  );
};
